import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a parking icon (e.g. displayed in standstills).
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ParkingIcon width={12} />
 */
const ParkingIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M25.47,15.76H21.09v7.87H25.4a4.07,4.07,0,0,0,2.91-1,3.55,3.55,
            0,0,0,1-2.7,4.39,4.39,0,0,0-1-3.05A3.64,3.64,0,0,0,25.47,15.76Z`}
        />
        <path
            d={`M41.66,2H6.29A4.3,4.3,0,0,0,2,6.31V41.69A4.3,4.3,0,0,0,6.29,
            46H41.66A4.3,4.3,0,0,0,46,41.69V6.31A4.3,4.3,0,0,0,41.66,2ZM33.12,
            26.31q-2.86,2.39-7.84,2.39h-4.2V38H14.51V10.68H25.4a12.68,12.68,0,
            0,1,5.54,1.15,8.67,8.67,0,0,1,3.73,3.28A9,9,0,0,1,36,19.93,7.89,
            7.89,0,0,1,33.12,26.31Z`}
        />
    </SvgIcon>
)

ParkingIcon.defaultProps = defaultProps

export { ParkingIcon }
